import React, { useEffect, useState } from "react";
import { Alert, Box, Button, Card, CircularProgress, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { API } from "../constant/apiConstant";
import { Colors } from "../utils/colors";

export default function AboutUs() {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ loading: true, content: "", error: false });
  useEffect(() => {
    let current = true;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    setState({ loading: true, content: "", error: false });
    (async () => {
      try {
        const response = await fetch(`${API.BASE_URL}/api/settings/about-us`, { signal: controller.signal, cache: "no-store" });
        const data = await response.json();
        if (!response.ok || data.status !== true || typeof data.page?.content !== "string" || !data.page.content.trim()) throw new Error("Unavailable");
        if (current) setState({ loading: false, content: data.page.content, error: false });
      } catch (_) {
        if (current) setState({ loading: false, content: "", error: true });
      } finally { clearTimeout(timer); }
    })();
    return () => { current = false; clearTimeout(timer); controller.abort(); };
  }, [attempt]);
  return (
    <Box sx={{ display: "flex", justifyContent: "center", pb: 10 }}>
      <Card component="article" sx={{ width: "100%", maxWidth: 900, p: { xs: 3, md: 5 }, borderRadius: 2, background: "#fff" }}>
        <Typography component="h1" variant="h4" fontWeight={700} sx={{ color: Colors.secondary, mb: 3 }}>About Us</Typography>
        {state.loading ? <CircularProgress aria-label="Loading About Us" /> : state.error ? (
          <Alert severity="error" action={<Button onClick={() => setAttempt(value => value + 1)}>Retry</Button>}>Unable to load About Us. Please try again.</Alert>
        ) : <Typography component="div" sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere", lineHeight: 1.9, color: Colors.text }}>{state.content}</Typography>}
        <Stack spacing={2} sx={{ mt: 3 }}>
          <Button component={RouterLink} to="/buy" variant="contained" sx={{ bgcolor: Colors.secondary, minHeight: 48 }}>Buy Tickets</Button>
          <Link href="https://fliplottery.com">Visit Flip Lottery</Link>
          <Link component={RouterLink} to="/terms-and-conditions">Read the terms and conditions</Link>
        </Stack>
      </Card>
    </Box>
  );
}
